import u from "./index.es43.js";
function o(t) {
  const e = {
    status: t ? "draft" : "published",
    populate: {
      subjectGroups: {
        populate: {
          subjects: {
            populate: {
              subject: {
                populate: "*"
              }
            }
          }
        }
      },
      subjects: {
        populate: {
          subject: {
            populate: "*"
          }
        }
      },
      links: {
        populate: "*"
      }
    }
  };
  return u.stringify(e);
}
export {
  o as default
};
//# sourceMappingURL=index.es9.js.map
